import { jsx, jsxs } from "react/jsx-runtime";
import { FetchStatus } from "../../../utils/buffer/types.js";
import { StatusWrapper, Status } from "./Styles.js";
import { useTranslation } from "react-i18next";
const StatusBar = ({ fetchStatus, empty }) => {
  const { t } = useTranslation();
  if (fetchStatus === FetchStatus.loading) {
    return /* @__PURE__ */ jsx(StatusWrapper, { children: /* @__PURE__ */ jsxs(Status, { children: [
      t("sheet.table.cells.enum.loading"),
      "."
    ] }) });
  }
  if (fetchStatus === FetchStatus.failed) {
    return /* @__PURE__ */ jsx(StatusWrapper, { children: /* @__PURE__ */ jsx(Status, { children: t("sheet.table.cells.enum.loadingError") }) });
  }
  if (fetchStatus === FetchStatus.success && empty) {
    return /* @__PURE__ */ jsx(StatusWrapper, { children: /* @__PURE__ */ jsx(Status, { italic: true, children: t("sheet.table.cells.enum.noMatchesFound") }) });
  }
  return null;
};
export {
  StatusBar
};
